import React from "react";
import styled from "styled-components";
import FlexBox from "../../components/Shared/FlexBox";
import Container from "../../components/Shared/Container";
import Link from "../../components/Shared/Link";
import Title from "../../components/Shared/Title";
import brands from "../../brands.json";

const Section = styled.section`
  width: 100%;
  background-color: #fff;
  padding: 80px 0;
  display: flex;
  justify-content: center;

  ${Container} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  ${Title} {
    margin-bottom: 40px;
  }

  @media (max-width: 767px) {
    padding: 60px 0;
  }
`;

const BrandGrid = styled(FlexBox)`
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  width: 100%;
  max-width: 1200px;
`;

const BrandCard = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #333;
  width: 180px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
  }

  img {
    width: 160px;
    height: 160px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 12px;
  }

  p {
    font-size: 14px;
    text-align: center;
    letter-spacing: 0.5px;
    line-height: 1.4;
  }

  @media (max-width: 767px) {
    width: 140px;

    img {
      width: 120px;
      height: 120px;
    }

    p {
      font-size: 13px;
    }
  }
`;

const PartialMarketComponent = () => {
  return (
    <Section id="market">
      <Container>
        <Title title="合作品牌" en="SURFING BRANDS" />
        <BrandGrid>
          {brands.filter(c => (!!c.id && !!c.img)).map((b, idx) => (
            <BrandCard key={idx} to={`/brand/${b.id}`}>
              <img src={b.img} alt={b.name} loading="lazy" />
              <p>{b.name}</p>
            </BrandCard>
          ))}
        </BrandGrid>
      </Container>
    </Section>
  );
};

export default PartialMarketComponent;
